import React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { borders, colors, spaces, typography } from '@99designs/emu/settings';

const Column = styled.div`
    flex-grow: 1;
    padding: ${spaces['0.75bu']};
    padding-bottom: 0;
    border-left: ${borders.content};

    &:first-child {
        border-left: none;
        padding-left: 0;
    }

    &::last-child {
        padding-right: 0;
    }
`;

const Amount = styled.div`
    font-family: ${typography.fontFamilies.heading};
    font-weight: ${typography.fontWeights.heading};
    letter-spacing: ${typography.headings[3].letterSpacing};
    font-size: ${typography.typeScale.size5}px;
    display: block;
    margin: 0;
    line-height: 1;
    white-space: nowrap;

    ${mediaQuery.only('small')} {
        font-size: ${typography.typeScale.size4}px;
    }
`;

const Label = styled.div`
    line-height: ${typography.lineHeights.paragraphs.small};
    color: ${colors.grey700};
    font-size: ${typography.typeScale.size1}px;

    ${mediaQuery.only('small')} {
        font-size: 10px;
    }
`;

export function Stat({ amount, label }: { amount: string | number; label: string }) {
    return (
        <div>
            <Amount>{amount}</Amount>
            <Label>{label}</Label>
        </div>
    );
}

function StatsTable({ children }: { children?: React.ReactNode }) {
    return (
        <Box display="flex" marginBottom="0.5bu">
            {React.Children.map(children, (child) => (
                <Column>{child}</Column>
            ))}
        </Box>
    );
}

export default StatsTable;
